export default __webpack_public_path__ + "static/media/ascend_gallery.1f07f549.png";